import { useEffect, useRef, useState } from "react";
import { HitAvatar, avatarBus, nextFx } from "@/components/avatar/HitAvatar";
import { frameOf } from "@/components/avatar/RankPanel";

const IDLE_MS = 120000;
const WAKE_EVENTS = ["pointermove", "pointerdown", "keydown", "scroll", "touchstart"];

// Avatar del encabezado: activo, aburrido tras 120 s, pensando al buscar/filtrar, salta al notificar.
export const HeaderAvatar = ({ user }) => {
  const [state, setState] = useState("active");
  const [fx, setFx] = useState("");
  const thinking = useRef(false);
  const lastAct = useRef(Date.now());

  useEffect(() => {
    const wake = () => { lastAct.current = Date.now(); setState((s) => (s === "bored" ? "active" : s)); };
    WAKE_EVENTS.forEach((e) => window.addEventListener(e, wake, { passive: true }));
    const tick = setInterval(() => {
      if (!thinking.current && Date.now() - lastAct.current > IDLE_MS) setState("bored");
    }, 1000);
    const onNotify = () => { lastAct.current = Date.now(); setState(thinking.current ? "thinking" : "active"); setFx(nextFx("notify")); };
    const onThink = (e) => { thinking.current = e.detail; lastAct.current = Date.now(); setState(e.detail ? "thinking" : "active"); };
    window.addEventListener("hit-avatar:notify", onNotify);
    window.addEventListener("hit-avatar:thinking", onThink);
    return () => {
      WAKE_EVENTS.forEach((e) => window.removeEventListener(e, wake));
      clearInterval(tick);
      window.removeEventListener("hit-avatar:notify", onNotify);
      window.removeEventListener("hit-avatar:thinking", onThink);
    };
  }, []);

  return (
    <button type="button" onClick={() => avatarBus.openPicker("cambiar")} aria-label="Cambiar avatar" data-testid="header-avatar"
      data-state={state} className="relative grid place-items-center w-10 h-10 rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FF4438]">
      <HitAvatar avatarId={user?.avatar_id} name={user?.name} size={36} state={state} fx={fx} toward="left" rank={frameOf(user)} />
    </button>
  );
};
